/* tslint:disable */
/* eslint-disable */
export enum TargetGraphType {
  PercentageCorrectResponding = 0,
  PromptPercentageDistribution = 1,
  PromptCounts = 2,
  TrialsByPrompts = 3,
  DailyPromptPercentage = 4,
  TimeOfDay = 5,
  FrequencySimple = 6,
  DurationSum = 7,
  DurationCount = 8,
  QuantitySum = 9,
  QuantityCount = 10,
  FluencyAverage = 11,
  FluencyIndividual = 12,
  GroupedFrequency = 13,
  TaskAnalysisLine = 14,
  ConditionalDescrimination = 15,
  CombinationSeparated = 16,
  CombinationMerged = 17,
  DurationPercentageOnSession = 18,
  TaskAnalysisBarSimple = 19,
  TaskAnalysisBarPromptCount = 20,
  TaskAnalysisBarPromptPercentage = 21,
  ToiletingLineColumn = 22,
  ToiletingBar = 23,
  ToiletingPie = 24,
  ToiletingPercentageCorrect = 25,
  WholePartialIntervalCorrect = 26,
  DurationTrialsTimeOfDay = 27,
  DurationPercentageOnGoal = 28,
  Currency = 29,
  TrialCount = 30,
  DurationByTrial = 31,
  ToiletingAccidentsVsSuccesses = 32,
  FluencyPercentCorrectWithElapsedTime = 33,
  WholePartialIntervalNotHappened = 34,
  Anecdotal = 35,
  IntensityBar = 36,
  IntensityOverTime = 37,
  InstancesPerMinute = 38,
  InstancesPerHour = 39
}
